import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={11}
      height={20}
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M5.5 20C2.46 20 0 17.54 0 14.5V4c0-2.21 1.79-4 4-4s4 1.79 4 4v8.5a2.5 2.5 0 01-5 0V5h2v7.59c0 .55 1 .55 1 0V4c0-1.1-.9-2-2-2s-2 .9-2 2v10.5C2 16.43 3.57 18 5.5 18S9 16.43 9 14.5V5h2v9.5c0 3.04-2.46 5.5-5.5 5.5z"
        fill="#000"
        fillOpacity={0.7}
      />
    </Svg>
  );
}

export default SvgComponent;
